import * as React from 'react';

export const NavigationContext = React.createContext();